import React, { FC } from 'react';
import { CircularProgressProps, LinearProgress, Typography } from '@mui/material';
import Container from './Container';
import M24Logo from './icons/M24Logo';
import { SeasonalLoader } from '../seasonal'; // SEASONAL: remove together with src/seasonal

export interface LoaderProps extends CircularProgressProps {
  loadingText?: string;
  width?: string;
  height?: string;
}

export const Loader: FC<LoaderProps> = ({ loadingText, width = '300px', height = '100px', ...progressProps }) => {
  const loader = (
    <Container column fullHeight>
      <M24Logo color='secondary' width={width} height={height} />
      <LinearProgress sx={{ width: '100%' }} variant='indeterminate' color='secondary' {...progressProps} />
      {loadingText && <Typography>{loadingText}</Typography>}
    </Container>
  );
  // SEASONAL: remove together with src/seasonal and return `loader` directly
  return (
    <SeasonalLoader
      loadingText={loadingText}
      width={width}
      height={height}
      progressProps={progressProps}
      fallback={loader}
    />
  );
};

export default Loader;
